import theme from '../base'

const pickerDay = {
  MuiPickersDay: {
    styleOverrides: {
      root: {
        margin: theme.spacing(0, 0.25),
      },
    },
  },
}

export default pickerDay
